module.exports = __webpack_public_path__ + "img/draw-bg.071e6f97.png";